import { Routes, Route } from "react-router-dom"
import NotFoundError from "../../components/Alerts/NotFoundError"
import ModelFamilies from "./pages/ModelFamilies"
import IndividualModelFamily from "./pages/IndividualModelFamily"
import IndividualModel from "./pages/IndividualModel"


export default function ModelsRoutes() {

    return (
        <Routes>
            <Route index element={<ModelFamilies />} />
            <Route path=':id' element={<IndividualModelFamily />} />
            <Route path=':model_family_id/:model_id' element={<IndividualModel />} />
            <Route path='404' element={<NotFoundError />} />
        </Routes>
    )
}